export const API_URL: string = import.meta.env.VITE_NORDWORK_API_URL;

export const APP_MODE = import.meta.env.MODE as "development" | "production" | "stage";